// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"440":"news-detail","594":"about","671":"services","794":"cases","983":"products"}[chunkId] + "." + {"440":"713db2ec","594":"bd1f8cd7","671":"4ac5aa7c","794":"8c8a8adb","983":"664487be"}[chunkId] + ".js";
};